import { useMemo } from "react";
import useInfiniteScroll from "react-infinite-scroll-hook";

import homeIconBlue from "../../../assets/homeIconBlue.svg";
import { EntityType, ServiceRequestVM } from "@propertelligent/client-api";
import EmptyState from "../../emptystate";
import ServiceRequestCardItem from "../../serviceRequest/ServiceRequestCardItem";
import SimpleSpinner from "../../../components/loader";
import { GetImages } from "../../../utils/GetImages";
import { usePermissions } from "../../../hooks/usePermissions";
import { useParams } from "react-router-dom";

interface DataHookState {
  rows: ServiceRequestVM[];
  loading: boolean;
  hasMore: any;
  fetchData: (page: number) => void;
  currentPage: number;
}

interface ServiceRequestProps {
  Id?: any;
  className?: string;
  Searchlength?: number;
  IsFooter?: boolean;
  dataHookState: DataHookState;
  showEmptyBox?: boolean;
  userRole?: "Landlord" | "Tenant" | "Contractor";
  hasAnyRequests?: boolean;
  entityTypeId?: EntityType;
  onAddClick?: () => void;
  onServiceRequestDeleted?: () => void;
  onServiceRequestVerified?: () => void;
  // True when this list is rendered inside a Property/Unit/Tenant/Contractor's own
  // embedded Service Requests tab -- threaded down to each ServiceRequestCardItem's Edit
  // drawer so Property/Unit stay locked there (bug/sr-edit-unlock).
  isEntity?: boolean;
}

const ServiceRequestCard: React.FC<ServiceRequestProps> = ({
  Id,
  className = "",
  Searchlength,
  IsFooter = true,
  dataHookState,
  showEmptyBox = true,
  userRole = "Landlord",
  hasAnyRequests = false,
  entityTypeId,
  onAddClick,
  onServiceRequestDeleted,
  onServiceRequestVerified,
  isEntity = false,
}) => {
  const { canWrite } = usePermissions();
  const { rows, loading, hasMore, fetchData, currentPage } = dataHookState;
  const params = useParams();

  const tenantUnitId = Number(params.unitId);

  
  const loadMoreRecords = () => {
    if (!loading && hasMore) {
      fetchData(currentPage + 1);
    }
  };

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore,
    onLoadMore: loadMoreRecords,
    disabled: !hasMore,
    rootMargin: "0px 0px 100px 0px",
  });





  return (
    <div className="infinite-scroll-container">
      {loading && rows.length === 0 ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1 h-100 w-100">
          <SimpleSpinner myClassName="Icon50" />
        </div>
      ) : rows.length === 0 && !loading ? (
        <EmptyState
          icon={GetImages.emptyStateServiceRequest}
          heading={"No Service Requests Found"}

          isButton={
            !(
              tenantUnitId == 0 &&
              entityTypeId == EntityType.Tenant
            ) &&

            entityTypeId !== EntityType.Contractor &&
            !hasAnyRequests &&
            (userRole === "Tenant" || canWrite("ServiceRequest"))
          }
          buttonLabel="Add Service Request"
          onButtonClick={onAddClick}
        />
      ) : (
        <>
          {rows.map((listingData) => (
            <ServiceRequestCardItem
              key={listingData.id}
              listingData={listingData}
              className={className}
              IsFooter={IsFooter}
              fetchData={fetchData} // Pass fetchData for refresh after delete
              userRole={userRole}
              onServiceRequestDeleted={onServiceRequestDeleted}
              onServiceRequestVerified={onServiceRequestVerified}
              isEntity={isEntity}
            />
          ))}
          {(loading || hasMore) && (
            <div ref={sentryRef} className="loading-trigger">
              {loading && (
                <SimpleSpinner myClassName="Icon40" />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ServiceRequestCard;